export enum EReturnShipmentStatuses {
  RETURN_STANDARD_RETURN_FINISHED = 'RETURN_STANDARD_RETURN_FINISHED',
  RETURN_EASY_RETURN_FINISHED = 'RETURN_EASY_RETURN_FINISHED',
}
